import { alpha, useTheme } from '@mui/material';
import { ConfigProvider } from 'antd';
import { FC, PropsWithChildren } from 'react';
import { ThemeMode } from './types/config';
import { getNightOrDayPalette } from './utils/getNightOrDayPalette';

export const AntdConfig: FC<PropsWithChildren> = ({ children }) => {
	const theme = useTheme();

	return (
		<ConfigProvider
			theme={{
				token: {
					colorPrimary: theme.palette.primary.main,
					colorTextBase: theme.palette[getNightOrDayPalette(theme)][900],
					colorBgBase: theme.palette.mode === ThemeMode.DARK ? theme.palette.night[100] : theme.palette.day[0],
					colorLink: theme.palette.mode === ThemeMode.DARK ? theme.palette.primary.main : theme.palette.day[0],
				},
				components: {
					DatePicker: {
						cellActiveWithRangeBg: theme.palette.mode === ThemeMode.DARK ? theme.palette.primary.dark : theme.palette.primary.lighter,
						cellHoverWithRangeBg:
							theme.palette.mode === ThemeMode.DARK ? alpha(theme.palette.primary.dark, 0.75) : alpha(theme.palette.primary.lighter, 0.75),

						colorIcon: theme.palette.mode === ThemeMode.DARK ? theme.palette.primary.main : theme.palette[getNightOrDayPalette(theme)].A50,
						colorIconHover: theme.palette[getNightOrDayPalette(theme)][800],
					},
				},
			}}
		>
			{children}
		</ConfigProvider>
	);
};
